import qwest from 'qwest';
import Customer from '../models/customer.jsx';
import TruBlueConfigModel from '../models/truBlueConfig.jsx';

let TruBlueApi = {
  registerCustomer(customer, pools, email) {
    return qwest.post('/TruBlue/RegisterTruBlueCustomer', {
      customerID: customer.id,
      storeAssociate: customer.storeAssociateTBSignUp,
      pools: pools.map(x => x.toApiFormat()),
      email,
    }).then((xhr, res) => res);
  },

  getConfig() {
    return new Promise((resolve, reject) => {
      qwest.get('/TruBlue/Config')
      .then((xhr, response) => {
        if (response.success) {
          try {
            let data = response.data;

            if (!data) {
              data = new TruBlueConfigModel({});
            } else if (typeof data === 'string') {
              data = TruBlueConfigModel.fromApiFormat(data);
            }
            resolve(data);
          } catch (e) {
            console.error(e);
            reject(response);
          }
        } else {
          reject(response);
        }
      });
    });
  },

};

export default TruBlueApi;
